module.exports = __webpack_public_path__ + "static/media/sd.25749d59.svg";